
<ScheduledReportForm ref="scheduledReportForm" :is-edit-mode="false" @submit="handleSubmit" />
